module.exports = __webpack_public_path__ + "img/notviewiconproctor.bf92a45d.svg";